<template>
  <ProductTitledBlock
    icon=""
    v-if="!model.hidden && description"
    class="mt-6 pr-[30px] font-light print:mx-0"
    :title="model.title || $t('shared.catalog.product_details.description_block_title')"
  >
    <VcCollapsibleContent max-height="18.75rem">
      <VcMarkdownRender :src="description" />
    </VcCollapsibleContent>
  </ProductTitledBlock>
</template>

<script setup lang="ts">
import { computed } from "vue";
import ProductTitledBlock from "../product-titled-block.vue";
import type { Product } from "@/core/api/graphql/types";

interface IProps {
  product: Product;
  model: {
    title?: string;
    hidden?: boolean;
  };
}

const props = defineProps<IProps>();

const description = computed(() => {
  const types = props.product.descriptions || [];
  const onelinerDescription = types.filter((item) => item.reviewType === "Product long");
  return onelinerDescription.length > 0 ? onelinerDescription[0].content : null;
});
</script>
